import { render, staticRenderFns } from "./newReportMsg.vue?vue&type=template&id=08f35d19&scoped=true&"
import script from "./newReportMsg.vue?vue&type=script&lang=js&"
export * from "./newReportMsg.vue?vue&type=script&lang=js&"
import style0 from "./newReportMsg.vue?vue&type=style&index=0&id=08f35d19&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f35d19",
  null
  
)

export default component.exports